var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardCredIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6146 12.6978L12.6979 50.6145L10.6355 48.5521L48.5522 10.6355L50.6146 12.6978Z",
    fill: "#0A435B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7645 6.22286C40.2549 5.7132 39.3991 5.7132 38.8894 6.22286L6.22273 38.8895C5.71308 39.3992 5.71308 40.255 6.22273 40.7646L29.2352 63.7771C29.7449 64.2868 30.6007 64.2868 31.1103 63.7771L63.777 31.1105C64.2774 30.61 64.2985 29.7772 63.769 29.2273L40.7645 6.22286ZM36.827 4.16046C38.4757 2.51178 41.1782 2.51178 42.8269 4.16046L65.8531 27.1867C67.4761 28.8536 67.4955 31.5167 65.8394 33.1729L33.1727 65.8395C31.5241 67.4882 28.8215 67.4882 27.1728 65.8395L4.16034 42.827C2.51166 41.1783 2.51166 38.4758 4.16034 36.8271L36.827 4.16046Z",
    fill: "#0A435B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCredIcon);
export default __webpack_public_path__ + "static/media/cardCred-icon.f7e58e8ed5c98d99edfe3548e9c97309.svg";
export { ForwardRef as ReactComponent };